import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-callout',
    templateUrl: './block-callout.component.html',
    standalone: false,
})
export class BlockCalloutComponent extends BlockAbstractComponent implements OnInit {
    override ngOnInit() {
        super.ngOnInit();

        // Set default style variant for pre-existing (legacy) Callout blocks
        // that haven't had the new (DI) update apply
        if (!this.block.data.customTheme) {
            this.block.data.styleVariant ??= 'border-accent';
            this.block.data.themeColor ??= 'primary';
        }

        // Fallback to default CTA value
        this.block.data.includeCTA ??= !!this.block.data.linkUrl;
    }
}
